define(["require", "exports", "knockout"], function (require, exports, ko) {
    "use strict";
    var AgentModel = /** @class */ (function () {
        function AgentModel(data) {
            this.Id = ko.observable(0);
            this.Name = ko.observable();
            var self = this;
            if (data) {
                ko.mapping.fromJS(data, AgentModel.Mapping, self);
            }
        }
        AgentModel.Mapping = {
            key: function (data) {
                return data.Id;
            },
            create: function (options) {
                return new AgentModel(options.data);
            }
        };
        return AgentModel;
    }());
    return AgentModel;
});
//# sourceMappingURL=AgentModel.js.map


//////////////////
// WEBPACK FOOTER
// ./build/models/AgentModel.js
// module id = 218
// module chunks = 2